import { render, staticRenderFns } from "./CompanyReviewPanel.vue?vue&type=template&id=2351e75e&scoped=true"
import script from "./CompanyReviewPanel.vue?vue&type=script&lang=js"
export * from "./CompanyReviewPanel.vue?vue&type=script&lang=js"
import style0 from "./CompanyReviewPanel.vue?vue&type=style&index=0&id=2351e75e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2351e75e",
  null
  
)

export default component.exports